import CalculatorsController from '../../src/javascripts/cvm';
import SymplrPdm from '../../src/javascripts/models/symplr/pdm';
import '../../src/javascripts/helpers/application/fa_checkbox_helper';
import '../../src/javascripts/helpers/symplr/pdm/hubspot_helpers';
// import '../../src/javascripts/helpers/application/self_service_pdf_launcher';
import '../../src/javascripts/helpers/symplr/pdm/production_selection_dependencies';
import '../../src/javascripts/helpers/symplr/pdm/calculated_fields_helper';
import '../../src/stylesheets/symplr/symplr_shared.scss';
import '../../src/stylesheets/symplr/pdm.scss';

(function() {
  $(() => CalculatorsController.run(new SymplrPdm()));
}).call(this);
